<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_piranshahr-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_piranshahr-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.9375;"
  >
    <div
      id="g-p3_piranshahr-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_piranshahr-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.5798%;margin-top:-11.1px;left:0.1832%;width:198px;"
    >
      <p class="g-pstyle0">IRGC radar site in Piranshahr</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:17.1869%;margin-top:-7.5px;left:6.7427%;width:77px;"
    >
      <p class="g-pstyle1">Piranshahr</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:22.0165%;margin-top:-7.5px;left:17.1092%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.7665%;margin-top:-7.5px;left:66.8288%;width:120px;"
    >
      <p class="g-pstyle3">Structure destroyed</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_piranshahr-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.08050847457627;"
  >
    <div
      id="g-p3_piranshahr-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_piranshahr-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9415%;margin-top:-11.2px;left:0%;width:223px;"
    >
      <p class="g-pstyle0">IRGC radar site in Piranshahr</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.9699%;margin-top:-7.5px;left:5.1061%;width:77px;"
    >
      <p class="g-pstyle1">Piranshahr</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:15.3598%;margin-top:-7.5px;left:11.3249%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:31.2496%;margin-top:-7.5px;left:39.6245%;margin-left:-60px;width:120px;"
    >
      <p class="g-pstyle3">Structure destroyed</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_piranshahr-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.09090909090909;"
  >
    <div
      id="g-p3_piranshahr-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_piranshahr-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.8727%;margin-top:-11.3px;left:0%;width:274px;"
    >
      <p class="g-pstyle0">IRGC radar site in Piranshahr</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.4184%;margin-top:-9.1px;left:5.1348%;width:86px;"
    >
      <p class="g-pstyle1">Piranshahr</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.7241%;margin-top:-9.1px;left:11.3799%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.7572%;margin-top:-9.1px;left:39.7193%;margin-left:-68.5px;width:137px;"
    >
      <p class="g-pstyle3">Structure destroyed</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_piranshahr-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-p3_piranshahr-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_piranshahr-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-p3_piranshahr-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.93548387096774;"
  >
    <div
      id="g-p3_piranshahr-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_piranshahr-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:19 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:19 -->
<!-- ai file: p3_piranshahr.ai -->
<style lang="scss">
  #g-p3_piranshahr-box,
  #g-p3_piranshahr-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_piranshahr-box p {
    margin: 0;
  }
  #g-p3_piranshahr-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_piranshahr-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_piranshahr-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_piranshahr-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_piranshahr-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_piranshahr-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_piranshahr-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-p3_piranshahr-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-p3_piranshahr-xl {
        display: block !important;
      }
    }
  }
  #g-p3_piranshahr-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_piranshahr-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_piranshahr-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_piranshahr-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_piranshahr-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_piranshahr-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  #g-p3_piranshahr-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_piranshahr-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_piranshahr-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_piranshahr-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_piranshahr-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_piranshahr-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_piranshahr-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_piranshahr-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_piranshahr-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_piranshahr-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_piranshahr-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_piranshahr-md .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_piranshahr-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_piranshahr-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_piranshahr-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_piranshahr-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_piranshahr-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-p3_piranshahr-xl {
    position: relative;
    overflow: hidden;
  }
  #g-p3_piranshahr-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_piranshahr-xl .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_piranshahr-xl .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_piranshahr-xl .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
